var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClearIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12137 7.59C8.26799 7.73625 8.26799 7.97626 8.12137 8.12251C7.97512 8.26876 7.73738 8.26876 7.59075 8.12251L6.00224 6.53252L4.4025 8.13373C4.25475 8.27998 4.01551 8.27998 3.86776 8.13373C3.72038 7.98373 3.72038 7.74375 3.86776 7.5975L5.46751 5.99625L3.879 4.41C3.73237 4.26375 3.73237 4.02374 3.879 3.87749C4.02487 3.73124 4.26262 3.73124 4.40925 3.87749L5.99776 5.46748L7.6095 3.85501C7.75725 3.70876 7.99612 3.70876 8.14387 3.85501C8.29124 4.00501 8.29124 4.24124 8.14387 4.39124L6.53249 6.00375L8.12137 7.59ZM6 0C2.68613 0 0 2.685 0 6C0 9.315 2.68613 12 6 12C9.31388 12 12 9.315 12 6C12 2.685 9.31388 0 6 0Z",
    fill: "#CED0DA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClearIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear-icon.9e142e41.svg";
export { ForwardRef as ReactComponent };